import React, { useEffect, useRef } from 'react';
import { CellContent } from 'src/pages/OfferPage/TableSvgOrganizer/CellContent';

export const TableCell = (props: any) => {
  const { width, numeric, cellCallback, children, icon, hasWrapper, hasIcon } =
    props;

  const newCellRef = useRef<any>(null);

  useEffect(() => {
    if (cellCallback) {
      cellCallback(newCellRef);
    }
  }, [cellCallback]);

  return (
    <td
      className={numeric ? "numeric-cell" : ""}
      width={width || "auto"}
      ref={newCellRef}
    >
      {hasWrapper ? (
        <div
          className="tableCellImageContainer"
          style={{
            marginTop: "10px",
            fontWeight: "600",
            display: "flex",
            alignItems: "center",
            textAlign: "left",
          }}
        >
          <CellContent icon={icon} hasIcon={hasIcon} children={children} />
        </div>
      ) : (
        <CellContent icon={icon} hasIcon={hasIcon} children={children} />
      )}
    </td>
  );
};
